import type { Assistant } from "@inrev/assistant";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { assistantEnabledQueryKey } from "../assistant.keys";

export const useFetchAssistantEnabled = () => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: assistantEnabledQueryKey,
		queryFn: async () => get<Assistant.Dtos.Enabled.Get.Response>("/v2/admin/assistant/enabled"),
		staleTime: 60_000,
	});

	return {
		assistantEnabled: query.data?.enabled === true,
		assistantEnabledIsLoading: query.isLoading,
	};
};
